import { z } from 'zod';

const ChartAxisTypeSchema = z.enum(['category', 'time', 'numeric']);

const ChartSeriesTypeSchema = z.enum(['line', 'bar', 'area']);

const ChartXAxisSchema = z.object({
	type: ChartAxisTypeSchema,
	data: z.array(z.union([z.string(), z.number()])),
	label: z.string()
}).strip();

const ChartYAxisSchema = z.object({
	label: z.string()
}).strip();

const ChartSeriesItemSchema = z.object({
	id: z.string(),
	label: z.string(),
	data: z.array(z.number()),
	type: ChartSeriesTypeSchema
}).strip();

const ChartEntitySchema = z.object({
	code: z.string(),
	name: z.string(),
	groupCode: z.string().optional(),
	groupName: z.string().optional()
}).strip();

const ChartGroupMappingSchema = z.object({
	groupCode: z.string(),
	groupName: z.string(),
	entityCodes: z.array(z.string())
}).strip();

const ChartFiltersSchema = z.object({
	years: z.array(z.number()),
	entities: z.array(ChartEntitySchema),
	defaultEntity: z.string().optional(),
	groupMappings: z.array(ChartGroupMappingSchema).optional()
}).strip();

const ChartMetadataSchema = z.object({
	generatedAt: z.string().datetime()
}).strip();

export const UniversalChartDataSchema = z.object({
	xAxis: ChartXAxisSchema,
	yAxis: ChartYAxisSchema,
	series: z.array(ChartSeriesItemSchema),
	filters: ChartFiltersSchema,
	metadata: ChartMetadataSchema
}).strip();


/**
 * Nivo Charts Data Format Schemas
 * Direct format for Nivo chart components
 */
const NivoLineDataPointSchema = z.object({
	x: z.union([z.string(), z.number()]),
	y: z.number()
}).strip();

const NivoLineSeriesSchema = z.object({
	id: z.string(),
	label: z.string(),
	data: z.array(NivoLineDataPointSchema)
}).strip();

export const NivoLineChartDataSchema = z.object({
	series: z.array(NivoLineSeriesSchema),
	filters: ChartFiltersSchema,
	metadata: ChartMetadataSchema
}).strip();


const NivoStackedBarDataItemSchema = z.record(z.union([z.string(), z.number()]));

export const NivoStackedBarChartDataSchema = z.object({
	data: z.array(NivoStackedBarDataItemSchema),
	keys: z.array(z.string()),
	indexBy: z.string(),
	filters: ChartFiltersSchema,
	metadata: ChartMetadataSchema
}).strip();

const ChoroplethDataItemSchema = z.object({
	name: z.string(),
	value: z.number(),
	maTinh: z.string(),
	tenTinh: z.string()
}).strip();

export const ChoroplethDataSchema = z.object({
	year: z.number(),
	data: z.array(ChoroplethDataItemSchema),
	availableYears: z.array(z.number()),
	maxValue: z.number(),
	minValue: z.number()
}).strip();
